export default class StopWatch {
    constructor(group) {
        this.unsupported = (
            !console.table // eslint-disable-line no-console
            || !window.performance
            || !window.performance.mark
            || !window.performance.measure
        );

        this.group = group;
        this.id = group + Math.random();
        this.lapCount = 0;
        this.lap('Start');
    }

    getMarkName(mark) {
        return `${this.id}>${mark}`;
    }

    mark(mark) {
        if (this.unsupported) return;
        window.performance.mark(this.getMarkName(mark));
    }

    lap(name) {
        if (this.unsupported) return;

        const mark = this.getMarkName(name);
        window.performance.mark(mark);

        if (this.prevMark) {
            window.performance.measure(mark, this.prevMark, mark);
            this.lapCount++;
        }

        this.prevMark = mark;
    }

    print() {
        if (this.unsupported) return;
        if (this.lapCount < 1) this.lap('Total');

        const entries = window.performance
            .getEntriesByType('measure')
            .filter(entry => entry.name.startsWith(this.id));

        const measurements = entries.map(entry => ({name: entry.name.split('>')[1], duration: entry.duration}));

        if (measurements.length > 1) {
            const lastMeasurement = entries[entries.length - 1];
            const totalDuration = (lastMeasurement.startTime - entries[0].startTime) + lastMeasurement.duration;
            measurements.push({name: 'Total', duration: totalDuration});
        }

        const tableData = {};
        measurements.forEach(entry => tableData[entry.name] = entry);

        /* eslint-disable no-console */
        console.group(`Performance measurements > ${this.group}`);
        console.table(tableData, ['duration']);
        console.groupEnd();
        /* eslint-enable no-console */
    }
}



// WEBPACK FOOTER //
// ./scripts/utils/stopwatch.js